import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'
import { Observable } from 'rxjs'
import { TabTyypit } from './kirjanpito.component'

@Component({
  selector: 'app-kirjanpito-lahetykset',
  templateUrl: './kirjanpito-lahetykset.component.html',
  styleUrls: ['./kirjanpito-lahetykset.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitoLahetyksetComponent implements OnInit, OnDestroy {
  @Input() yhdistettyStatusObservable: Observable<'yes' | 'no' | 'not-saved-yet'>
  @Input() valittuTabObservable: Observable<TabTyypit>
  @Input() veroilmoitusLahetettyObservable: Observable<boolean>
  @Input() naytaIlmoitusValilehtiObservable: Observable<boolean>
  @Input() naytaVeroilmoitusValilehtiObservable: Observable<boolean>
  @Input() onkoSpostejaLahetetty: boolean

  @Output() vaihdaAlvIlmoitukseen = new EventEmitter()
  @Output() vaihdaVeroilmoitukseen = new EventEmitter()
  @Output() vaihdaLahetaNakymaan = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}
}
